export default __webpack_public_path__ + "static/media/material-lizard.0f83914c.svg";